export function fileViewUrl(gcsPath: string): string {
  return `/api/files/view?path=${encodeURIComponent(gcsPath)}`;
}
